import React from 'react';

import './Header.css';
import { view } from 'react-easy-state';

export default view((props) => (
  <header className={
    (props.className ? props.className : '')
  }>{props.children}</header>
));